<template>
  <transition name="bounce">
    <div class="prompt-win create-story">
      <div class="inner">
        <p class="title">新的故事</p>
        <p class="hint-note">请输入您的故事名称</p>
        <input type="text" class="import-name" v-model.trim="storyName" v-on:input="textDetection">
        <div class="btn-container clearfix">
          <a href="javascript:;" class="btn" @click="closeModal">取消</a>
          <a href="javascript:;" class="btn" @click="submitCreateStory">确定</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import {ComponentName, Methods} from '../const/common';
  import {ProjectData} from "../store/ProjectData";

  export default {
    name: 'org_modal',
    computed: mapState(['parrent']),
    store,
    data() {
      return {
        projectData: new ProjectData(this),
        storyName: this.autoStoreName()
      }
    },
    methods: {
      textDetection() {
        this.storyName = this.storyName.replace(store.state.nameReg, '').replace(store.state.emoReg, '');
      },
      autoStoreName() {
        let _length = 1;

        if (store.state.myStorysLength >= 0) {
          _length = store.state.myStorysLength + 1;
        }
        return '我的作品' + _length;
      },
      closeModal() {
        Methods.cutComponent([ComponentName.CREATE_STORY_WIN], false)
        Methods.checkChapterHash(7);
      },
      submitCreateStory() {
        let storyName = this.storyName, _this = this;

        if (storyName === '') {
          return Toast({
            message: '作品名不能为空',
            duration: 2000
          });
        }
        //todo 生成作品
        Methods.cutComponent('all', false);
        if (_this.parrent.createType === 0) {
          this.$nextTick(function () {
            setTimeout(function () {
              Methods.cutComponent([ComponentName.EDIT_STORY], true);
            }, 800);
          });
          Methods.setHeaderConf('editStory', '返回', ComponentName.STORYS_LIST);
        } else {
          Methods.cutComponent([ComponentName.EDIT_STORY_ROLE], true);
          Methods.setHeaderConf('editStoryRole', '风格选择', ComponentName.CREATEION_TYPE);
        }
        Middle.MiddleData.CreateProject(storyName, this.parrent.style, this.parrent.createPattern, this.parrent.useModal, this.setStoryDetail, this);
        store.state.storyStyle = Middle.ProjectData.header.style;
        store.commit('editStorySetout');
        Methods.checkChapterHash(6);
      },
      setStoryDetail() {
        this.projectData.saveStory(null,null);
        // Middle.ServerPort.GetInstance().saveProject();
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/org_modal.css";
</style>



// WEBPACK FOOTER //
// src/components/create_story_win.vue